import {
    Skeleton as UiSkeleton,
    Typography as UiTypography,
    styled,
    styledForMobile,
} from "@l2r-front/l2r-ui"

export const Skeleton = styled(UiSkeleton)({
    height: 24,
    transform: "scale(1)",
    width: 220,
})

export const RoadDetailWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 8, 8, 8),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}))

export const Wrapper = styledForMobile("div")(({ isMobile, theme }) => ({
    backgroundColor: theme.palette["colors/gris/150"].main,
    display: "flex",
    flexDirection: "column",
    height: "fit-content",
    flex: 1,
    padding: isMobile ? theme.spacing(5) : theme.spacing(8),
}))

export const Container = styledForMobile("div")(({ isMobile }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: !isMobile && "auto",
}))

export const ErrorText = styled(UiTypography)(({ theme }) => ({
    color: theme.palette["texts/text-error"].main,
    marginTop: theme.spacing(5),
}))

export const LocationHeader = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
})